import { Avatar, Card, CardHeader } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import useCurrentMenu from 'common/hooks/useCurrentMenu'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

const StyledMenu = styled((props) => <Menu {...props} />)(() => ({
  '& .MuiPaper-root': {
    boxShadow: 'var(--Paper-shadow);',
  },
}))

const WorkerCard = ({ datos, actions }) => {
  const menu = useCurrentMenu()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [selected, setSelected] = React.useState({})
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setSelected({
      user: event.currentTarget.dataset.worker,
      surname: event.currentTarget.dataset.surname,
      name: event.currentTarget.dataset.name,
      image: event.currentTarget.dataset.image,
      worker: event.currentTarget.dataset.workercode,
    })
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleAction = (e) => {
    setAnchorEl(null)
    const request = e.currentTarget.dataset.request
    navigate(`/${request}`, {
      state: {
        user: selected.user,
        surname: selected.surname,
        name: selected.name,
        image: selected.image,
        worker: selected.worker,
        report: menu?.actualMatch?.parametros?.INF_HISTORICO,
      },
    })
  }

  return (
    <Card sx={{ backgroundColor: 'white' }}>
      <CardHeader
        sx={{ cursor: 'pointer' }}
        avatar={
          <Avatar
            src={`/assets/images/${datos.imagen}`}
            sx={{
              transition: '.3s',
              aspectRatio: '4/4',
            }}
          />
        }
        title={[datos?.primer_apellido, datos?.segundo_apellido].filter(Boolean).join(' ')}
        subheader={`${datos?.nombre ?? ''}`}
        data-worker={datos.usuario_web}
        data-surname={[datos?.primer_apellido, datos?.segundo_apellido].filter(Boolean).join(' ')}
        data-name={`${datos?.nombre ?? ''}`}
        data-image={datos.imagen}
        data-workercode={datos.code_trabajador}
        onClick={handleClick}
      />
      <StyledMenu
        id="worker-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'worker-button',
        }}
        elevation={4}
      >
        {actions?.ver_ficha === 'S' ? (
          <MenuItem data-request="datos" onClick={handleAction} selected={false}>
            Ficha
          </MenuItem>
        ) : null}
        {actions?.ver_calendario === 'S' ? (
          <MenuItem data-request="calendario" onClick={handleAction} selected={false}>
            Calendario
          </MenuItem>
        ) : null}
        {actions?.ver_modelo_145 === 'S' ? (
          <MenuItem data-request="model145" onClick={handleAction} selected={false}>
            Modelo 145
          </MenuItem>
        ) : null}
        {actions?.ver_doc_laboral === 'S' ? (
          <MenuItem data-request="doclaboral" onClick={handleAction} selected={false}>
            Doc. Laboral
          </MenuItem>
        ) : null}
        {actions?.ver_doc_personal === 'S' ? (
          <MenuItem data-request="docpersonal" onClick={handleAction} selected={false}>
            Doc. Personal
          </MenuItem>
        ) : null}
        {actions?.ver_hist_fichajes === 'S' ? (
          <MenuItem data-request="informes" onClick={handleAction} selected={false}>
            Fichajes
          </MenuItem>
        ) : null}
      </StyledMenu>
    </Card>
  )
}

export default WorkerCard
